module.exports = __webpack_public_path__ + "static/img/4932_phase_function_Paper_PointsHejduk_Prediction.86a25ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4932_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nVK0
// module chunks = 0